import axios from "axios";
import { API_ROOT } from "../config/constants";
import { refreshToken, updateAxiosToken } from "./auth";
import { getLocalItem } from "./localdb";

let headers;

// If auth token is in LS, update Axios instance
if (getLocalItem("authToken")) {
  headers = {
    "Authorization": `Bearer ${getLocalItem("authToken")}`,
  };
}

const axiosInstance = axios.create({
  baseURL: API_ROOT,
  headers: headers,
});

let tries = 0;

axiosInstance.interceptors.response.use(null, (err) => {
  if (err.response.status === 403) {
    return refreshToken()
      .then((authToken) => {
        updateAxiosToken(authToken);

        tries++;

        if (tries < 5) {
          return axiosInstance.request(err.config);
        }

        return Promise.reject(err);
      })
      .catch(() => {
        return Promise.reject(err);
      });
  }

  return Promise.reject(err);
});

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/utils/backend.js